<template>
  <div class="home">
    <div class="content">
      <el-button type="primary" icon="el-icon-upload2" class="userButton" @click="setUser">文件上传</el-button>
      <el-button type="primary" icon="el-icon-download" class="userButton" @click="downFile">文件下载</el-button>
      <el-button type="danger" icon="el-icon-delete" class="userButton" @click="deleteFile">删除文件</el-button>
      <div style="width:30%;float:left;margin-left:28px;margin-top:10px;" v-if="fileProgress">
        <el-progress :text-inside="true" :stroke-width="18" :percentage="fileScreen" status="success"></el-progress>
      </div>
      <el-table :data="theFileList"
        style="width:99%;border:2px solid #eee;margin:auto;margin-top:10px;margin-bottom:1%;"
        :header-cell-style="getRowClass" @selection-change="handleSelectionChange" v-loading="loading" height="291px">
        <el-table-column type="selection" width="50" align="center">
        </el-table-column>
        <el-table-column type="index" align="center" label="序号" width="80"></el-table-column>
        <el-table-column v-if="false" prop="file_id" header-align="center" align="center">
        </el-table-column>
        <el-table-column prop="file_name" align="center" label="数据名称"></el-table-column>
        <el-table-column prop="name" align="center" label="文件名称"></el-table-column>
        <el-table-column prop="file_size" align="center" label="文件大小" width="150px"></el-table-column>
        <el-table-column align="center" label="文件状态" width="150px">
          <template slot-scope="scope">
            <span
              :class="scope.row.state == 0 ? 'error':'success' ">{{scope.row.state==0?'未导入':(scope.row.state==1?'已导入基准数据':(scope.row.state==2?'已导入时延数据':'--'))}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" align="center" label="上传时间" width="240px"></el-table-column>
      </el-table>
      <!-- <div style="text-align:center">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next" :total="totalProject"
          @current-change="thPageChange" v-if="totalProject>pageSize">
        </el-pagination>
      </div> -->
      <div class="importData" style="border:0">
        <el-row>
          <el-col :span="7">
            <div class="theFile">
              <h2>
                <span style="margin-left:20px;color:#909399;">基准数据</span>
              </h2>
              <div style="text-align:center;line-height:55px;" v-loading="loadingBenchmark"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div style="width:60%;position:absolute;top:5px;left:118px;" v-if="leftProgress">
                  <el-progress :text-inside="true" :stroke-width="18" :percentage="theSipScreen" status="success">
                  </el-progress>
                </div>
                <el-button type="primary" @click="importBenchmark">导入数据</el-button>
                <el-button type="primary" @click="clearBenchmark" :disabled="sipScreen">清除数据</el-button>
                <el-button type="primary" @click="sipImport" :disabled="sipScreen">数据筛选</el-button>
                <span style="display:block;font-size:14px;text-align:left;padding-left:16%;">数据数量：{{benchmark |
                  makeData}}（条）<el-button type="text" style="float:right;margin-right:20%;margin-top:2%;"
                    @click="watchSip">查看重复数据</el-button></span>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="theFile" style="border:1px solid #fff;">
              <img src="@/assets/rightArrow.png" alt="" class='qwerLeft'>
              <img src="@/assets/rightArrow.png" alt="" class='qwerRight'>
              <div class="circular">
                <input type="text"
                  style="width:90%;margin:0 auto;border:0px;margin-top:-20px;background-color:cyan;font-size:16px;text-align:center;color:gray;cursor: pointer"
                  v-model="equipmentInput" @blur="equipment">
                <span class="circularName">（可重命名）</span>
              </div>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="theFile">
              <h2>
                <span style="margin-left:20px;color:#909399;">时延数据</span>
              </h2>
              <div style="text-align:center;line-height:55px;" v-loading="loadingDelay"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div style="width:60%;position:absolute;top:5px;left:118px;" v-if="rightProgress">
                  <el-progress :text-inside="true" :stroke-width="18" :percentage="theCscfScreen" status="success">
                  </el-progress>
                </div>
                <el-button type="primary" @click="importDelay">导入数据</el-button>
                <el-button type="primary" @click="clearDelay" :disabled="cscfScreen">清除数据</el-button>
                <el-button type="primary" @click="cscfImport" :disabled="cscfScreen">数据筛选</el-button>
                <span style="display:block;font-size:14px;text-align:left;padding-left:16%;">数据数量：{{delay |
                  makeData}}（条）<el-button type="text" style="float:right;margin-right:20%;margin-top:2%;"
                    @click="watchCscf">查看重复数据</el-button></span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="result">
        <h2><span style="margin-left:20px;position:relative;"><i class="theI"></i>筛选计算和结果显示</span></h2>
        <el-row>
          <el-col :span="24">
            <div style="height:50px;"></div>
            <div class="theFile">
              <h2>
                <span style="margin-left:20px;color:#909399;">时延测试结果</span>
                <span id="sipStatus" v-if="cscfLoad">正在计算</span>
              </h2>
              <p class="theClick">&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button type="primary" icon="el-icon-edit" @click="showCscf" style="float:left;margin-left:10px;"
                  v-if="judge" :disabled="beginNum">开始计算</el-button>
                <el-button type="primary" icon="el-icon-refresh" @click="showReset" style="float:left;margin-left:10px;"
                  :disabled="allReset">重置</el-button>
                <!-- <el-button type="danger" style="float:left;margin-left:10px;" v-if="!judge">中断退出</el-button> -->
              </p>
              <div style="width:40%;position:absolute;top:-40px;left:260px;" v-if="makeNum">
                <el-progress :text-inside="true" :stroke-width="18" :percentage="makeNumScreen" status="success">
                </el-progress>
              </div>
              <el-row>
                <el-col :span="8">
                  <div style="margin-top:20px;text-align:left;margin-left:50px;">
                    <b>被测设备</b>：{{equipmentInput}}
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div style="text-align:left;margin-top:25px;margin-left:50px;">
                    有效数据：{{effective | makeData}}（条）
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="news">
                    <ul>
                      <li>平均时延：&nbsp;{{cscfAvg | makeData}}&nbsp;(μs)</li>
                      <li>最大时延：&nbsp;{{maxresult | makeData}}&nbsp;(μs)</li>
                      <li>最小时延：&nbsp;{{minresult | makeData}}&nbsp;(μs)</li>
                    </ul>
                  </div>
                </el-col>
              </el-row>
              <div style="margin-top:18px;text-align:left;padding-left:50px;">
                <el-button type="primary" @click="lookMore">极值详情</el-button>
                <el-button type="primary" @click="doorMore">门限值筛选</el-button>
                <el-button type="primary" @click="allSaves">保存</el-button>
              </div>
              <div class="theLoad" v-if="cscfLoad">
                <i class="el-icon-loading"></i>
                <p>拼命计算中</p>
              </div>
              <div class="theLoad" v-if="cscfLoads">
                <p style="margin:160px auto;">CSCF（7072）数据正在筛选，请耐心等待。。。</p>
              </div>
              <div class="theLoad" v-if="cscfLoadTwo">
                <p style="margin:160px auto;">SIP数据正在筛选，请耐心等待。。。</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 文件上传 -->
      <el-dialog title="数据文件上传" :visible.sync="manageFile" width="500px" :show-close="false"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="fileTable" ref="createFile" label-width="100px" class="demo-ruleForm">
          <el-form-item label="文件上传：">
            <input type="file" :disabled="uping" ref="fil" accept=".txt,.csv">
            <span class="tips">允许上传的文件格式为.txt,.csv</span>
          </el-form-item><br>
          <el-form-item label="数据名称：">
            <el-input type="test" v-model="fileTable.fileName" class="userInput" clearable placeholder="请输入数据名称">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="sure">确 定</el-button>
        </span>
        <!-- <div class="theLoads" v-if="fileUps">
          <i class="el-icon-loading"></i>
          <p>正在上传，请您耐心等待</p>
        </div> -->
      </el-dialog>
      <!-- 基准数据筛选 -->
      <el-dialog title="筛选基准数据" :visible.sync="makeSipFile" width="400px" :show-close="false"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="newForm1" :model="sipForm" label-width="100px">
          <el-form-item label="时间：">
            <el-input v-model="sipForm.theSecond" style="width:128px;float:left;margin-left:38px;" type='number'></el-input>（秒）
          </el-form-item>
          <el-form-item label="规则类型：">
            <el-radio-group v-model="sipForm.resource">
              <p class="sip_p" style="margin-top:10px">
                <el-radio :label="1">取重复数据的第一条记录</el-radio>
              </p>
              <p class="sip_p">
                <el-radio :label="2">取重复数据的最后一条记录</el-radio>
              </p>
              <!-- <p class="sip_p">
                <el-radio :label="3">12秒内保留第一条的选项</el-radio>
              </p> -->
            </el-radio-group>
          </el-form-item>
        </el-form><br>
        <el-button @click="cancelSip">取 消</el-button>
        <el-button type="primary" @click="sureSip">确 定</el-button>
        <!-- <div class="theLoad" v-if="loadSip">
          <i class="el-icon-loading"></i>
          <p>拼命筛选中</p>
        </div> -->
      </el-dialog>
      <!-- 时延数据筛选 -->
      <el-dialog title="筛选时延数据" :visible.sync="makeCscfFile" width="400px" :show-close="false"
        :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form ref="newForm2" :model="cscfForm" label-width="100px">
          <el-form-item label="时间：">
            <el-input v-model="cscfForm.theSecond" style="width:128px;float:left;margin-left:18px;" type='number'></el-input>（秒）
          </el-form-item>
          <el-form-item label="规则类型：">
            <el-radio-group v-model="cscfForm.resource">
              <p class="sip_p" style="margin-top:10px">
                <el-radio :label="1">取重复数据的第一条记录</el-radio>
              </p>
              <p class="sip_p">
                <el-radio :label="2">取重复数据的最后一条记录</el-radio>
              </p>
              <!-- <p class="sip_p">
                <el-radio :label="3">12秒内保留第一条的选项</el-radio>
              </p> -->
            </el-radio-group>
          </el-form-item>
        </el-form><br>
        <el-button @click="cancelCscf">取 消</el-button>
        <el-button type="primary" @click="sureCscf">确 定</el-button>
        <!-- <div class="theLoad" v-if="loadCscf">
          <i class="el-icon-loading"></i>
          <p>拼命筛选中</p>
        </div> -->
      </el-dialog>
      <!-- 极值详情查看 -->
      <el-dialog title="极值详情查看" :visible.sync="details" width="680px">
        <el-row>
          <el-col :span="12">
            <div class="news">
              <span class="theTap">最大时延详情</span>
              <ul>
                <li><span>UE_id：</span>&nbsp;{{maxtel}}&nbsp;</li>
                <li><span>基准时间：</span>&nbsp;{{maxsipm | makeData}}&nbsp;(s)</li>
                <li><span>时延时间：</span>&nbsp;{{maxcscfm | makeData}}&nbsp;(s)</li>
              </ul>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="news">
              <span class="theTap"></span>
              <ul>
                <li></li>
                <li><span></span>&nbsp;{{maxsipms | makeData}}&nbsp;(μs)</li>
                <li><span></span>&nbsp;{{maxcscfms | makeData}}&nbsp;(μs)</li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="12">
            <div class="news">
              <span class="theTap">最小时延详情</span>
              <ul>
                <li><span>UE_id：</span>&nbsp;{{mintel}}&nbsp;</li>
                <li><span>基准时间：</span>&nbsp;{{minsipm | makeData}}&nbsp;(s)</li>
                <li><span>时延时间：</span>&nbsp;{{mincscfm | makeData}}&nbsp;(s)</li>
              </ul>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="news">
              <span class="theTap"></span>
              <ul>
                <li></li>
                <li><span></span>&nbsp;{{minsipms | makeData}}&nbsp;(μs)</li>
                <li><span></span>&nbsp;{{mincscfms | makeData}}&nbsp;(μs)</li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 门限值筛选 -->
      <el-dialog title="门限值筛选" :visible.sync="door" width="800px" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false">
        <i class="el-icon-close" style="position:absolute;top:20px;right:20px;font-size:20px;cursor:pointer;"
          @click="handleClose"></i>
        <el-row>
          <el-col :span="20">
            <div class="news">
              <span class="theTap">筛选条件</span>
              <ul>
                <li>
                  <span style="font-size:26px;">≥</span>（大于等于）：&nbsp;
                  <input type="number" placeholder="请输入条件数值" v-model="doorValue"
                    style="width:360px;height:35px;padding-left:10px;" />&nbsp;(μs)
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="news">
              <span class="theTap"></span>
              <ul>
                <li>
                  <el-button type="primary" @click="doorSure">确定</el-button>
                </li>
                <li></li>
              </ul>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="news">
              <span class="theTap">筛选结果</span>
              <ul>
                <li><span>筛选后数据个数：</span>&nbsp;{{doorSome}}&nbsp;(条)</li>
                <li><span>数据总数：</span>&nbsp;{{doorCount}}&nbsp;(条)</li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
      <!-- 重复数据查看 -->
      <el-dialog :title="repeatName" :visible.sync="sipDoor" width="980px" :close-on-click-modal="false"
        :close-on-press-escape="false" :show-close="false">
        <i class="el-icon-close" style="position:absolute;top:20px;right:20px;font-size:20px;cursor:pointer;"
          @click="sipClose"></i>
        <el-table :data="repeatData" border style="width: 100%" height="290" v-loading="repeatLoading"
          element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-table-column type="index" label="序号" width="70px" align="center">
          </el-table-column>
          <el-table-column prop="m" label="秒" width="180px" align="center">
          </el-table-column>
          <el-table-column prop="ms" label="毫秒" width="180px" align="center">
          </el-table-column>
          <el-table-column prop="tel" label="Tel" align="center">
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import api from '@/api/home';
import {
  downloadUrl
} from '@/common/common';
export default {
  name: 'home',
  data () {
    return {
      doorSome: '',
      doorCount: '',
      radioSip: '',
      repeatName: '',
      theFileUp: true,
      repeatLoading: true,
      theSipScreen: 0, //基准数据进度条值
      theCscfScreen: 0, //时延数据进度条值
      makeNumScreen: 0, //开始计算进度条值
      fileScreen: 0, //文件上传进度条值
      leftProgress: false, //基准数据进度条
      rightProgress: false, //时延数据进度条
      makeNum: false, //开始计算进度条
      fileProgress: false, //上传文件进度条
      timer: null, //上传文件定时器
      leftImport: null, //基准导入定时器
      leftScreen: null, //基准筛选定时器
      rightImport: null, //时延导入定时器
      rightScreen: null, //时延筛选定时器
      calculation: null, //开始计算定时器
      selectVal: [],
      getNewSelect: [],
      repeatData: [],
      loadingBenchmark: false,
      loadingDelay: false,
      num: '',
      judge: true,
      beginNum: true,
      allReset: false,
      equipmentInput: '',
      benchmark: '',
      delay: '',
      details: false,
      door: false,
      sipDoor: false,
      // cscfDoor: false,
      sipLoad: false,
      sipLoads: false,
      cscfLoad: false,
      cscfLoads: false,
      cscfLoadTwo: false,
      tasLoad: false,
      manageFile: false,
      uping: false,
      makeSipFile: false,
      makeCscfFile: false,
      makeTasFile: false,
      loadSip: false,
      loadCscf: false,
      loadTas: false,
      fileUps: false,
      demoCscf: false,
      demoTas: false,
      loading: false,
      sipScreen: false,//基准数据模块按钮是否禁用
      cscfScreen: false,//时延数据模块按钮是否禁用
      sipForm: {},
      cscfForm: {},
      tasForm: {},
      fileTable: {},
      theFileList: [], //上传文件的表数组
      totalProject: 0, //表格总条数
      pageSize: 5, //表格每页条数
      currentPage: 1, //表格当前页数
      sipFile: [],
      cscfFile: [],
      tasFile: [],
      effective: '', //保存start
      cscfAvg: '',
      maxresult: '',
      minresult: '',
      maxcscfm: '',
      maxcscfms: '',
      maxsipm: '',
      maxsipms: '',
      maxtel: '',
      mincscfm: '',
      mincscfms: '',
      minsipm: '',
      minsipms: '',
      mintel: '', //保存end
      doorValue: ''
    }
  },
  created () {
    this.getFileList();
    this.getStatuAll();
    this.getAgoNum()
  },
  //将小数四舍五入为整数且千分位展示（过滤器）
  filters: {
    makeData: str => {
      if (str) {
        str = Number(str).toFixed(0).toString().split('').reverse().join('').replace(/(\d{3})/g,
          '$1,').split('').reverse().join(
            '')
        if (str.substring(0, 1) == '-' && str.substring(1, 2) == ',') {
          return str = str.slice(0, 1) + str.slice(2, str.length)
        } else {
          if (str.substring(0, 1) == ',') {
            return str.slice(1, str.length)
          } else {
            return str
          }
        }
      } else {
        if (str == 0) {
          return str
        } else {
          return ''
        }
      }
    }
  },
  methods: {
    //查看基准重复数据
    watchSip () {
      this.sipDoor = true;
      this.repeatLoading = true;
      this.repeatName = '基准重复数据列表';
      api.selectError({
        num: 1
      }).then(res => {
        console.log("sip", res)
        if (res.data.list) {
          this.repeatData = res.data.list;
          this.repeatLoading = false
        }
      })
    },
    //查看基准重复数据
    watchCscf () {
      this.sipDoor = true;
      this.repeatLoading = true;
      this.repeatName = '时延重复数据列表';
      api.selectError({
        num: 2
      }).then(res => {
        console.log("cscf", res)
        this.repeatData = res.data.list;
        this.repeatLoading = false
      })
    },
    //获取上次计算结果
    getAgoNum () {
      api.statu({
        num: 3
      }).then(res => {
        if (res.data.statu == 1) {
          this.cscfLoad = false;
          this.beginNum = true;
          this.allReset = false;
          this.effective = res.data.count;
          this.cscfAvg = res.data.cscfAvg;
          this.maxresult = res.data.cscfMax.result;
          this.minresult = res.data.cscfMin.result;
          this.maxcscfm = res.data.cscfMax.cscfm;
          this.maxcscfms = res.data.cscfMax.cscfms;
          this.maxsipm = res.data.cscfMax.sipm;
          this.maxsipms = res.data.cscfMax.sipms;
          this.maxtel = res.data.cscfMax.tel;
          this.mincscfm = res.data.cscfMin.cscfm;
          this.mincscfms = res.data.cscfMin.cscfms;
          this.minsipm = res.data.cscfMin.sipm;
          this.minsipms = res.data.cscfMin.sipms;
          this.mintel = res.data.cscfMin.tel
        }
      })
    },
    // 基准数据筛选轮询
    alwaysMakeSip () {
      setTimeout(() => {
        api.statu({
          num: 2,
          screen: 1
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.leftScreen);
            this.leftScreen = null;
            this.sipScreen = false;
            setTimeout(() => {
              this.leftProgress = false
            }, 2);
            this.getFileList();
            this.cancelSip();
            this.$message.success("基准数据筛选成功")
          } else {
            this.leftProgress = true;
            this.sipScreen = true
          }
        })
      }, 5000);
      this.leftScreen = setInterval(() => {
        api.statu({
          num: 2,
          screen: 1
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.leftScreen);
            this.leftScreen = null;
            this.sipScreen = false;
            setTimeout(() => {
              this.leftProgress = false
            }, 2000);
            this.getFileList();
            this.cancelSip();
            this.$message.success("基准数据筛选成功")
          } else {
            this.leftProgress = true;
            this.sipScreen = true
          }
        });
        api.progress({
          num: 2
        }).then(res => {
          this.theSipScreen = this.getPercentage(res.data.num, res.data.count)
        })
      }, 10000)
    },
    // 时延数据筛选轮询
    alwaysMakeCscf () {
      setTimeout(() => {
        api.statu({
          num: 2,
          screen: 2
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.rightScreen);
            this.rightScreen = null;
            this.cscfScreen = false;
            setTimeout(() => {
              this.rightProgress = false
            }, 2000);
            this.getFileList();
            this.cancelCscf();
            this.$message.success("时延数据筛选成功")
          } else {
            this.rightProgress = true;
            this.cscfScreen = true
          }
        })
      }, 5000);
      this.rightScreen = setInterval(() => {
        api.statu({
          num: 2,
          screen: 2
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.rightScreen);
            this.rightScreen = null;
            this.cscfScreen = false;
            setTimeout(() => {
              this.rightProgress = false
            }, 2000);
            this.getFileList();
            this.cancelCscf();
            this.$message.success("时延数据筛选成功")
          } else {
            this.rightProgress = true;
            this.cscfScreen = true
          }
        });
        api.progress({
          num: 3
        }).then(res => {
          this.theCscfScreen = this.getPercentage(res.data.num, res.data.count)
        })
      }, 10000)
    },
    // 基准数据导入轮询
    importLeftMall () {
      setTimeout(() => {
        api.statu({
          num: 1,
          screenImport: 1
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.leftImport);
            this.leftImport = null;
            this.loadingBenchmark = false;
            this.pageSize = 5;
            this.currentPage = 1;
            this.getFileList();
            this.sipFile = res.data.list;
            this.$message.success("导入基准数据成功")
          } else {
            this.loadingBenchmark = true
          }
        })
      }, 5000);
      this.leftImport = setInterval(() => {
        api.statu({
          num: 1,
          screenImport: 1
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.leftImport);
            this.leftImport = null;
            this.loadingBenchmark = false;
            this.pageSize = 5;
            this.currentPage = 1;
            this.getFileList();
            this.sipFile = res.data.list;
            this.$message.success("导入基准数据成功")
          }
        })
      }, 10000);
    },
    //时延数据导入轮询
    importRightMall () {
      setTimeout(() => {
        api.statu({
          num: 1,
          screenImport: 2
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.rightImport);
            this.rightImport = null;
            this.loadingDelay = false;
            this.pageSize = 5;
            this.currentPage = 1;
            this.getFileList();
            this.sipFile = res.data.list;
            this.$message.success("导入时延数据成功")
          } else {
            this.loadingDelay = true
          }
        })
      }, 5000);
      this.rightImport = setInterval(() => {
        api.statu({
          num: 1,
          screenImport: 2
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.rightImport);
            this.rightImport = null;
            this.loadingDelay = false;
            this.pageSize = 5;
            this.currentPage = 1;
            this.getFileList();
            this.sipFile = res.data.list;
            this.$message.success("导入时延数据成功")
          }
        })
      }, 10000)
    },
    // 开始计算轮询
    alwaysMakeNum () {
      setTimeout(() => {
        api.statu({
          num: 3
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.calculation);
            this.calculation = null;
            this.cscfLoad = false;
            this.beginNum = true;
            this.allReset = false;
            this.effective = res.data.count;
            this.cscfAvg = res.data.cscfAvg;
            this.maxresult = res.data.cscfMax.result;
            this.minresult = res.data.cscfMin.result;
            this.maxcscfm = res.data.cscfMax.cscfm;
            this.maxcscfms = res.data.cscfMax.cscfms;
            this.maxsipm = res.data.cscfMax.sipm;
            this.maxsipms = res.data.cscfMax.sipms;
            this.maxtel = res.data.cscfMax.tel;
            this.mincscfm = res.data.cscfMin.cscfm;
            this.mincscfms = res.data.cscfMin.cscfms;
            this.minsipm = res.data.cscfMin.sipm;
            this.minsipms = res.data.cscfMin.sipms;
            this.mintel = res.data.cscfMin.tel;
            this.$message.success("计算成功");
            setTimeout(() => {
              this.makeNum = false
            }, 2000)
          } else {
            this.makeNum = true;
            this.cscfLoad = true;
            // this.beginNum = true
          }
        })
      }, 5000);
      this.calculation = setInterval(() => {
        api.statu({
          num: 3
        }).then(res => {
          if (res.data.statu == 1) {
            clearInterval(this.calculation);
            this.calculation = null;
            this.cscfLoad = false;
            this.beginNum = true;
            this.allReset = false;
            this.effective = res.data.count;
            this.cscfAvg = res.data.cscfAvg;
            this.maxresult = res.data.cscfMax.result;
            this.minresult = res.data.cscfMin.result;
            this.maxcscfm = res.data.cscfMax.cscfm;
            this.maxcscfms = res.data.cscfMax.cscfms;
            this.maxsipm = res.data.cscfMax.sipm;
            this.maxsipms = res.data.cscfMax.sipms;
            this.maxtel = res.data.cscfMax.tel;
            this.mincscfm = res.data.cscfMin.cscfm;
            this.mincscfms = res.data.cscfMin.cscfms;
            this.minsipm = res.data.cscfMin.sipm;
            this.minsipms = res.data.cscfMin.sipms;
            this.mintel = res.data.cscfMin.tel;
            this.$message.success("计算成功");
            setTimeout(() => {
              this.makeNum = false
            }, 2000)
          }
        });
        api.progress({
          num: 1
        }).then(res => {
          this.makeNumScreen = this.getPercentage(res.data.num, res.data.count)
        })
      }, 10000)
    },
    //重置开始计算
    showReset () {
      this.beginNum = false;
      this.allReset = true;
      this.effective = '';
      this.cscfAvg = '';
      this.maxresult = '';
      this.minresult = '';
      this.maxcscfm = '';
      this.maxcscfms = '';
      this.maxsipm = '';
      this.maxsipms = '';
      this.maxtel = '';
      this.mincscfm = '';
      this.mincscfms = '';
      this.minsipm = '';
      this.minsipms = '';
      this.mintel = ''
    },
    //基准数据筛选
    sureSip () {
      if (this.sipForm.resource&&this.sipForm.theSecond) {
        this.sipForm.theSecond = parseInt(this.sipForm.theSecond)        
        console.log(this.sipForm)
        this.theSipScreen = this.getPercentage(0, 1);
        this.leftProgress = true;
        this.makeSipFile = false;
        this.sipScreen = true;
        api.sip({
          num: this.sipForm.theSecond,
          id: this.sipForm.resource
        }).then(res => {
          if (res.data.statu == 2) {
            this.makeSipFile = false;
            this.$message.warning(res.data.msg);
            clearInterval(this.leftScreen);
            this.leftScreen = null
          }
        });
        this.alwaysMakeSip()
      } else {
        this.$message.warning("请填写和选择筛选条件")
        this.leftProgress = false
      }
    },
    //时延数据筛选
    sureCscf () {
      if (this.cscfForm.resource&&this.cscfForm.theSecond) {
        this.cscfForm.theSecond = parseInt(this.cscfForm.theSecond)        
        console.log(this.cscfForm);
        this.theCscfScreen = this.getPercentage(0, 1);
        this.rightProgress = true;
        this.makeCscfFile = false;
        this.cscfScreen = true;
        api.cscf({
          num: this.cscfForm.theSecond,
          id: this.cscfForm.resource
        }).then(res => {
          if (res.data.statu == 2) {
            this.$message.warning(res.data.msg);
            clearInterval(this.rightScreen);
            this.rightScreen = null
          }
        });
        this.alwaysMakeCscf()
      } else {
        this.$message.warning("请选择筛选条件");
        this.rightProgress = false
      }
    },
    // 开始计算
    showCscf () {
      this.cscfLoad = true;
      this.makeNum = true;
      this.beginNum = true;
      this.makeNumScreen = this.getPercentage(0, 1)
      api.jscscf().then(res => {
        if (res.data.statu == 2) {
          this.$message.warning(res.data.msg);
          clearInterval(this.calculation);
          this.calculation = null
        }
      });
      this.alwaysMakeNum()
    },
    //基准数据导入
    importBenchmark () {
      if (this.selectVal.length == 0) {
        this.$message.warning("请选择你要导入的文件")
      } else {
        if (this.selectVal.length > 1) {
          this.$message.warning("一次只能导入一条数据")
        } else {
          if (this.selectVal[0].state == 0) {
            this.loadingBenchmark = true;
            api.textSip({
              fileId: this.selectVal[0].file_id
            }).then(res => {
              if (res.data.statu == 2) {
                this.$message.warning(res.data.msg);
                clearInterval(this.leftImport);
                this.leftImport = null;
                this.loadingBenchmark = true
              }
            });
            this.importLeftMall()
          } else {
            this.loadingBenchmark = false;
            this.$message.warning("该文件不可再次导入")
          }
        }
      }
    },
    //时延数据导入
    importDelay () {
      if (this.selectVal.length == 0) {
        this.$message.warning("请选择你要导入的文件")
      } else {
        if (this.selectVal.length > 1) {
          this.$message.warning("一次只能导入一条数据")
        } else {
          if (this.selectVal[0].state == 0) {
            this.loadingDelay = true;
            api.textCscf({
              fileId: this.selectVal[0].file_id
            }).then(res => {
              if (res.data.statu == 2) {
                this.$message.warning(res.data.msg);
                clearInterval(this.rightImport);
                this.rightImport = null;
                this.loadingDelay = true
              }
            });
            this.importRightMall()
          } else {
            this.loadingDelay = false;
            this.$message.warning("该文件不可再次导入")
          }
        }
      }
    },
    //获取全部状态
    getStatuAll () {
      api.statu().then(res => {
        if (res.data.asynchronous.importdata == 2) {
          this.importLeftMall() // 基准数据导入轮询
        }
        if (res.data.asynchronous.calculation == 2) {
          this.alwaysMakeNum()  // 开始计算轮询
        }
        if (res.data.asynchronous.filtering == 2) {
          this.alwaysMakeCscf() // 时延数据筛选轮询
        }
        if (res.data.asynchronous.upload == 2) {
          this.alwaysMakeSip()  // 基准数据筛选轮询
        }
        if (res.data.asynchronous.screenImport == 2) {
          this.importRightMall() //时延数据导入轮询
        }
      })
    },
    // 门限值弹框关闭
    handleClose () {
      this.door = false;
      this.doorValue = '';
      this.doorSome = '';
      this.doorCount = ''
    },
    // 门限值弹框关闭
    sipClose () {
      this.sipDoor = false;
      this.repeatData = []
    },
    // 门限值弹框确定按钮
    doorSure () {
      api.selectLimit({
        delayTime: this.doorValue
      }).then(res => {
        this.doorSome = res.data.result
        this.doorCount = res.data.all
      })
    },
    //求百分比
    getPercentage (num, total) {
      num = parseFloat(num);
      total = parseFloat(total);
      if (isNaN(num) || isNaN(total)) {
        return "-";
      }
      return total <= 0 ? "0" : (Math.round(num / total * 10000) / 100);
    },
    //被测设备编辑
    equipment () {
      api.updateProjectName({
        name: this.equipmentInput
      }).then(res => {
        if (res.data.status == 200) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //清除基础数据
    clearBenchmark () {
      api.clearFront().then(res => {
        if (res.status == 200) {
          this.currentPage = 1;
          this.pageSize = 5;
          this.getFileList();
          this.$message.success("基础数据清除成功")
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //清除时延数据
    clearDelay () {
      api.clearLater().then(res => {
        if (res.status == 200) {
          this.currentPage = 1;
          this.pageSize = 5;
          this.getFileList();
          this.$message.success("时延数据清除成功")
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 极值详情查看
    lookMore () {
      this.details = true;
    },
    // 门限值详情查看
    doorMore () {
      this.door = true;
    },
    //基准数据筛选弹框
    sipImport () {
      this.makeSipFile = true
    },
    //时延数据筛选弹框
    cscfImport () {
      this.makeCscfFile = true
    },
    // 文件列表全查
    getFileList () {
      this.loading = true;
      this.selectVal.length = 0;
      api.selectFileList({
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res.status == 200) {
          this.totalProject = res.data.count;
          this.theFileList = res.data.list;
          this.benchmark = res.data.frontCount;
          this.delay = res.data.laterCount;
          this.equipmentInput = res.data.projctName;
          this.loading = false;
        } else {
          this.$message.error(res.msg)
        }
      });
    },
    // 文件列表分页中的当前页改变
    // thPageChange(val) {
    //   this.currentPage = val;
    //   this.getFileList();
    // },
    // 保存计算出的结果
    allSaves () {
      api.saveRecord({
        count: this.effective,
        cscfAvg: this.cscfAvg,
        maxcscfm: this.maxcscfm,
        maxcscfms: this.maxcscfms,
        maxresult: this.maxresult,
        maxsipm: this.maxsipm,
        maxsipms: this.maxsipms,
        maxtel: this.maxtel,
        mincscfm: this.mincscfm,
        mincscfms: this.mincscfms,
        minresult: this.minresult,
        minsipm: this.minsipm,
        minsipms: this.minsipms,
        mintel: this.mintel,
      }).then(res => {
        if (res.data.status == 200) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    //基准数据筛选取消
    cancelSip () {
      this.makeSipFile = false;
      this.sipForm = {}
    },
    //时延数据筛选取消
    cancelCscf () {
      this.makeCscfFile = false;
      this.cscfForm = {}
    },
    handleSelectionChange (val) {
      this.selectVal = val;
    },
    // 文件删除
    deleteFile () {
      if (this.selectVal.length == 0) {
        this.$message.warning('请选择要删除的内容')
      } else {
        this.$confirm('确认删除？')
          .then(_ => {
            api.deleteFile({
              fileId: this.selectVal.map(v => v.file_id).join(',')
            }).then(res => {
              if (res.status == 200) {
                this.currentPage = 1;
                this.pageSize = 5;
                this.getFileList();
                this.$message.success("文件删除成功")
              } else {
                this.$message.warning(res.msg)
                this.$message.error("文件删除失败")
              }
            })
          })
          .catch(_ => { });
      }
    },
    // 文件下载
    downFile () {
      if (this.selectVal.length == 0) {
        this.$message.warning("请选择你要下载的文件")
      } else {
        if (this.selectVal.length == 1) {
          window.location.href =
            downloadUrl + 'nausf-auth/fileDownload?fileId=' +
            // 'http://192.168.3.73:8080/nausf-auth/fileDownload?fileId=' +
            // 'http://192.168.3.105:8080/nausf-auth/fileDownload?fileId=' +
            // 'http://192.168.3.139:8080/nausf-auth/fileDownload?fileId=' +
            // 'http://choidata.choicete.com:8080/nausf-auth/fileDownload?fileId=' +
            this.selectVal.map(v =>
              v.file_id)
        } else {
          this.$message.warning("不支持批量下载")
        }
      }
    },
    //文件上传
    setUser () {
      this.manageFile = true;
    },
    //上传确定按钮点击事件
    sure () {
      this.$refs['createFile'].validate((valid) => {
        if (valid) {
          var _formData = new FormData();
          if (this.$refs.fil.files.length == 0) {
            this.$message.warning("请选择文件")
          } else {
            this.fileUps = true;
            this.fileProgress = true;
            var config = {
              onUploadProgress: progressEvent => {
                this.fileScreen = (progressEvent.loaded / progressEvent.total * 100 | 0)
              }
            }
            _formData.append('file', this.$refs.fil.files[0]);
            _formData.append('fileName', this.fileTable.fileName);
            api.fileUpload(_formData, config).then(res => {
              this.uping = false;
              if (res.data.status == 200) {
                this.getFileList();
                this.fileTable = {};
                this.manageFile = false;
                this.fileUps = false;
                this.$refs['fil'].value = null;
                setTimeout(() => {
                  this.fileProgress = false;
                  setTimeout(() => {
                    this.fileScreen = 0;
                  }, 1000);
                }, 2000);
                this.$message.success("文件上传成功");
              } else {
                this.$message.error("文件上传失败")
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    //取消按钮点击事件
    cancel () {
      this.fileTable = {};
      this.$refs['fil'].value = null;
      this.manageFile = false
    },
    //表头样式
    getRowClass ({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (rowIndex === 0) {
        return "background:#f9f9f9"
      } else {
        return ''
      }
    },
  }
}

</script>

<style scoped lang="scss">
@import "../common/css/common.css";

.home {
  margin: 10px;

  .content {
    width: 100%;
    .sip_p {
      height: 25px;
      text-align: left;
      line-height: 25px;
    }
    .qwerLeft {
      width: 15%;
      position: absolute;
      left: 5%;
      top: 18%;
      text-align: center;
    }

    .qwerRight {
      width: 15%;
      position: absolute;
      right: 5%;
      top: 18%;
      text-align: center;
    }

    .inputSize {
      width: 240px;
      height: 40px;
      border: 1px solid #ccc;
      margin-left: 100px;
    }

    .inputSizes {
      width: 240px;
      height: 40px;
      border: 1px solid #ccc;
      margin-left: 100px;
      float: left;
    }

    .news {
      width: 100%;

      .theTap {
        display: inline-block;
        width: 100%;
        height: 28px;
        line-height: 30px;
        text-align: left;
        font-size: 17px;
        font-weight: bold;
        letter-spacing: 2px;
        margin-left: 20px;
      }

      ul {
        width: 100%;

        li {
          list-style: none;
          height: 28px;
          line-height: 20px;
          text-align: left;
          margin-left: 50px;
          margin-top: 20px;
          font-size: 16px;
        }
      }
    }

    .theLoad {
      width: 100%;
      height: 165px;
      position: absolute;
      top: 60px;
      left: 0px;
      background: rgba($color: #000, $alpha: 0.7);

      i {
        font-size: 28px;
        margin: 0 auto;
        margin-top: 12%;
        color: #409eff;
      }

      p {
        font-size: 14px;
        color: #409eff;
        padding-top: 10px;
      }
    }

    .theLoads {
      width: 100%;
      height: 275px;
      position: absolute;
      top: 53px;
      left: 0px;
      background: rgba($color: #000, $alpha: 0.7);

      i {
        font-size: 28px;
        margin: 0 auto;
        margin-top: 20%;
        color: #409eff;
      }

      p {
        font-size: 14px;
        color: #409eff;
        padding-top: 10px;
      }
    }

    .thInput {
      width: 240px;
      margin-left: -50px;
    }

    .importData {
      width: 99%;
      border: 1px solid #ccc;
      margin: 10px auto;

      .theI {
        display: inline-block;
        width: 5px;
        height: 20px;
        background: #0057a9;
        position: absolute;
        top: 1px;
        left: -10px;
      }

      h2 {
        width: 100%;
        height: 40px;
        text-align: left;
        line-height: 40px;
        font-weight: bold;
        background: #f9f9f9;
        border-bottom: 1px solid #eee;
      }

      .theFile {
        width: 96%;
        // height: 158px;
        height: 140px;
        margin: 10px auto;
        border: 1px solid #ccc;
        position: relative;

        .circular {
          border: 5px solid #0057a9;
          width: 280px;
          height: 100px;
          border-radius: 35px;
          margin: 0 auto;
          margin-top: 15px;
          text-align: center;
          line-height: 108px;
          background: cyan;
          letter-spacing: 1px;
          position: relative;

          .circularName {
            height: 25px;
            width: 100px;
            line-height: 25px;
            color: #e36956;
            font-size: 14px;
            font-weight: bold;
            top: 70px;
            left: 86px;
            display: inline-block;
            position: absolute;
          }
        }

        .theLoad {
          width: 100%;
          height: 110px;
          position: absolute;
          top: 40px;
          left: 0px;
          background: rgba($color: #000, $alpha: 0.7);

          i {
            font-size: 28px;
            margin: 0 auto;
            margin-top: 6%;
            color: #409eff;
          }

          p {
            font-size: 14px;
            color: #409eff;
            padding-top: 10px;
          }
        }

        h2 {
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: left;
          font-weight: bold;
          background: #f9f9f9;
          border-bottom: 1px solid #eee;

          span {
            margin-left: 20px;
          }
        }

        .tips {
          display: inline-block;
          width: 270px;
          height: 30px;
          text-align: left;
          line-height: 30px;
          margin: 0 auto;
          margin-top: 10px;
          font-size: 12px;
          color: #c23531;
        }

        input {
          margin-top: 20px;
        }
      }
    }

    .result {
      width: 99%;
      border: 1px solid #ccc;
      margin: 0 auto;
      margin-top: 20px;

      .theI {
        display: inline-block;
        width: 5px;
        height: 20px;
        background: #0057a9;
        position: absolute;
        top: 1px;
        left: -10px;
      }

      h2 {
        width: 100%;
        height: 40px;
        text-align: left;
        line-height: 40px;
        font-weight: bold;
        background: #f9f9f9;
        border-bottom: 1px solid #eee;
      }

      .theFile {
        width: 98%;
        height: 300px;
        margin: 8px auto;
        border: 1px solid #ccc;
        margin-bottom: 20px;
        position: relative;

        .theLoad {
          width: 100%;
          height: 262px;
          position: absolute;
          // top: 41px;
          top: 38px;
          left: 0px;
          background: rgba($color: #000, $alpha: 0.7);

          i {
            font-size: 28px;
            margin: 0 auto;
            margin-top: 110px;
            color: #409eff;
          }

          p {
            font-size: 14px;
            color: #409eff;
            padding-top: 10px;
          }
        }

        h2 {
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: left;
          font-weight: bold;
          background: #f9f9f9;
          border-bottom: 1px solid #eee;

          span {
            margin-left: 20px;
          }

          #sipStatus {
            width: 80px;
            height: 18px;
            background: #93cea8;
            padding: 5px;
            float: right;
            margin-top: 6px;
            margin-right: 8px;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
            border-radius: 15px;
            color: #fff;
          }
        }

        .news {
          width: 100%;

          ul {
            width: 100%;

            li {
              width: 29%;
              height: 28px;
              line-height: 20px;
              text-align: left;
              float: left;
              margin-left: 50px;
              margin-top: 25px;
              font-size: 16px;
            }
          }
        }

        .theClick {
          width: 100%;
          position: absolute;
          top: -50px;
          left: 0px;
        }

        .theClicks {
          margin: 0 auto;
          margin-top: 90px;
        }
      }
    }

    .userButton {
      float: left;
      margin-bottom: 10px;
      margin-left: 10px;
    }

    .userInput {
      width: 280px;
    }

    .tips {
      display: inline-block;
      width: 270px;
      height: 30px;
      text-align: left;
      line-height: 30px;
      margin: 0 auto;
      margin-top: 10px;
      font-size: 12px;
      color: #c23531;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue